import React from "react";

const Footer = () => {
  return (
    <div>
      <section id="#footer">
        <footer className="text-center text-lg-start bg-primary text-muted">
          <section className="d-flex justify-content-center justify-content-lg-between p-4 border-bottom text-white">
            <div className="me-5 d-none d-lg-block">
              <span>Get connected with us on social networks:</span>
            </div>
            <div>
              <a href="founder#" className="me-4 text-reset">
                <i className="fa fa-facebook"></i>
              </a>
              <a href="footer#" className="me-4 text-reset">
                <i className="fa fa-twitter"></i>
              </a>
              <a
                href="https://mail.google.com/mail/u/0/?ogbl#inbox/FMfcgzGslbHWHfPHnNxpBpFVFzQWJQSH?compose=new"
                className="me-4 text-reset"
              >
                <i className="fa fa-google"></i>
              </a>
              <a
                href="https://www.instagram.com/duraivg09/"
                className="me-4 text-reset"
              >
                <i className="fa fa-instagram"></i>
              </a>
              <a href="new#" className="me-4 text-reset">
                <i className="fa fa-linkedin"></i>
              </a>
            </div>
          </section>

          <section id="#money" className="text-white">
            <div className="container text-center text-md-start mt-0 text-white">
              <div className="row">
                <div className="col-md-4 mx-auto mb-2">
                  <h6 className="text-uppercase fw-bold mb-4">
                    <i className="fas fa-gem me-3"></i>VGD TEXTILE MANUFACTURER
                  </h6>
                  <p>
                    Thank You for Visting for Website with Your Valuable
                    customers like You hope you will be happy with your family
                  </p>
                </div>

                <div className="col-md-4 mx-auto mb-0">
                  <h6 className="text-uppercase fw-bold mb-4">About</h6>
                  <p>
                    <a href="#!" className="text-reset">
                      Pricing
                    </a>
                  </p>
                  <p>
                    <a href="#!" className="text-reset">
                      Settings
                    </a>
                  </p>
                  <p>
                    <a href="#!" className="text-reset">
                      Orders
                    </a>
                  </p>
                  <p>
                    <a href="#!" className="text-reset">
                      Help
                    </a>
                  </p>
                </div>
                <div className="col-md-4 mx-auto mb-4">
                  <h6 className="text-uppercase fw-bold mb-4">Contact</h6>
                  <p>
                    <i className="fa fa-home me-3"></i>6/72C,Anna
                    nagar,Idappadi,Salem
                  </p>
                  <p>
                    <i className="fa fa-envelope me-3"></i>
                    vgdtexiles@gmail.com
                  </p>
                  <p>
                    <i className="fa fa-phone me-3"></i> +91 9488705946
                  </p>
                  <p>
                    <i className="fa fa-print me-3"></i> +91 9842085946
                  </p>
                </div>
              </div>
            </div>
            <div className="text-center p-4 text-white">
            ©Copyright @2023:
            <a className="text-reset fw-bold" href="https://vgd.com/">
              vgdtexiles
            </a>
          </div>
          </section>

          
        </footer>
      </section>
    </div>
  );
};

export default Footer;
